export enum USER_STATE {
  ACTIVE = 'active',
  NOT_VERIFIED = 'not_verified',
  DELETED = 'deleted',
  DISABLED = 'disabled',
  BLOCKED = 'blocked'
}
